var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignal = function SvgSignal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.636 5.636a.75.75 0 0 0-1.06-1.06c-4.101 4.1-4.101 10.748 0 14.848a.75.75 0 0 0 1.06-1.06 9 9 0 0 1 0-12.728M19.425 4.575a.75.75 0 1 0-1.061 1.06 9 9 0 0 1 0 12.729.75.75 0 1 0 1.06 1.06c4.101-4.1 4.101-10.748 0-14.849"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.757 7.757a.75.75 0 0 0-1.06-1.06 7.5 7.5 0 0 0 0 10.606.75.75 0 0 0 1.06-1.06 6 6 0 0 1 0-8.486M17.303 6.696a.75.75 0 1 0-1.06 1.061 6 6 0 0 1 0 8.485.75.75 0 1 0 1.06 1.061 7.5 7.5 0 0 0 0-10.607"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.879 9.878a.75.75 0 1 0-1.061-1.06 4.5 4.5 0 0 0 0 6.364.75.75 0 0 0 1.06-1.06 3 3 0 0 1 0-4.244M15.182 8.818a.75.75 0 1 0-1.06 1.06 3 3 0 0 1 0 4.243.75.75 0 0 0 1.06 1.06 4.5 4.5 0 0 0 0-6.363M12 10.875a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25"
  })));
};
export default SvgSignal;